import React, { Component } from 'react'
import { toast } from 'react-toastify'
import _ from 'lodash'
import { connect } from 'react-redux'
import { convertSearchObjectToBase64 } from 'utils/objToBase64'

import { Get, Put, GetFileGet } from 'utils/axios-token'
import Lang from 'Lang/General'

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      showCreateDialogs: false,
      loading: false,
      dialogs: [],
      searchParams: [
        {
          label: Lang['TEXT_PHRASE'][this.props.data.languageReducer.userSettings.admin_panel_language],
          col: 12,
          value: 'content',
          param: ''
        },
        {
          label: Lang['DIALOG_ID'][this.props.data.languageReducer.userSettings.admin_panel_language],
          col: 4,
          value: 'encrypted_id',
          param: ''
        }
      ],
      dialogssMeta: {
        current_page: 1,
        per_page: 10,
        last_page: 1,
        total_results: 1
      },
      selectedSetting: {},
      defaultQuery: window.location.href.indexOf('archive') > -1 
        ? {
          "is_paginated": true,
          "page": 1,
          "filter": {
            "status": "ARCHIVED"
          },
          "sort": ['-created_at']
        }
        : {
          "is_paginated": true,
          "page": 1,
          "filter": {
            "status": "ACTIVE"
          },
          "sort": ['-created_at']
        },
      selectedDialogs: null,
      selectedArchiveDialog: null,
      showEditModal: false,
      subscribedPackage: true,
      showDeleteConfirmation: false,
      showViewDialogsModal: false,
      query: window.location.href.indexOf('archive') > -1 
        ? {
          "is_paginated": true,
          "page": 1,
          "filter": {
            "status": "ARCHIVED"
          },
          "sort": ['-created_at']
        }
        : {
          "is_paginated": true,
          "page": 1,
          "filter": {
            "status": "ACTIVE"
          },
          "sort": ['-created_at']
        },
    }

    onChangeDialogsHOC = (key, val) => this.setState({ [key]: val })

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success(success)
    requestError = error => toast.error(error)

    getDialogs = (query) => {
      this.setState({ query })

      Get(
        `/api/v1/dialogues/${this.props.data.selectCenterReducer.selectedCenter.center.id}${!_.isEmpty(query) ? `?query=${convertSearchObjectToBase64(query)}` : ''}`,
        this.getDialogsSuccess,
        this.getDialogsError,
        this.load
      )
    }
    getDialogsSuccess = payload => this.setState({
      dialogs: _.map(payload.data, item => ({ ...item, status: Lang[item.is_active ? 'ACTIVE' : 'INACTIVE'][this.props.data.languageReducer.userSettings.admin_panel_language] })),
      dialogssMeta: payload.meta
    })
    getDialogsError = () => {}
    
    updateDialogs = (dataToSubmit) => {
      Put(
        `/api/v1/dialogs/${dataToSubmit.id}`,
        dataToSubmit,
        this.updateDialogsSuccess,
        this.updateDialogsError,
        this.load
      )
    }
    updateDialogsSuccess = () => {
      this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({
        selectedArchiveDialog: null,
        query: {...this.state.defaultQuery}
      }, () => this.getDialogs(this.state.query))
    }
    updateDialogsError = error => this.requestError(error)

    closeDialog = id => Put(
      `/api/v1/dialogues/close/${id}`,
      {},
      this.closeDialogSuccess,
      this.closeDialogError,
      this.load
    )
    closeDialogSuccess = () => {
      this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({
        selectedArchiveDialog: null
      }, () => this.getDialogs(this.state.query))
    }
    closeDialogError = error => this.requestError(error)

    getSelectedSetting = () => Get(
      `/api/v1/dialogues/centers/support/${this.props.data.selectCenterReducer.selectedCenter.center.id}`,
      payload => this.setState({selectedSetting: payload}),
      () => {},
      this.load
    )

     downwloadPDF = (id) => GetFileGet(
      `/api/v1/dialoguemessages/history/${this.props.data.selectCenterReducer.selectedCenter.center.id}/${id}`,
      `${id}.pdf`,
      () => {},
      error => this.requestError(error.toString()),
      this.load
    )

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onLoadDialogsHOC={this.state.loading}
          closeDialog={this.closeDialog}
          getDialogs={this.getDialogs}
          downwloadPDF={this.downwloadPDF}
          getSelectedSetting={this.getSelectedSetting}
          updateDialogs={this.updateDialogs}
          onChangeDialogsHOC={this.onChangeDialogsHOC}
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect(mapStateToProps)(WithHOC)
}

export default HOC